import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import AuthForm from 'components/AuthForm/AuthForm';
import RegisterForm from 'components/RegisterForm/RegisterForm';
import './AuthModal.scss';

export default function AuthModal({ open, onClose, initialMode = 'login' }) {
  const [mode, setMode] = useState(initialMode);
  
  useEffect(() => {
    setMode(initialMode);
  }, [initialMode]);

  if (!open) return null;

  const handleSwitchToRegister = () => setMode('register');
  const handleSwitchToLogin = () => setMode('login');

  const modalContent = (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-header">
          <h2 className="auth-modal-title">
            {mode === 'login' ? 'Вход' : 'Регистрация'}
          </h2>
          <button className="auth-close-btn" onClick={onClose}>×</button>
        </div>
        {mode === 'login' ? (
          <AuthForm onSuccess={onClose} onSwitchToRegister={handleSwitchToRegister} />
        ) : (
          <RegisterForm onSuccess={onClose} onSwitchToLogin={handleSwitchToLogin} />
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
